/**
 * One place for cache keys, so an invalidation after a write cannot miss a
 * reader. Every ledger write changes the cost report, which is why the report
 * keys are invalidated by more or less everything.
 */
export const queryKeys = {
  session: ['session'] as const,
  farm: ['farm'] as const,
  batches: ['batches'] as const,
  batch: (id: string) => ['batches', id] as const,
  birdEvents: (batchId: string) => ['bird-events', batchId] as const,
  materials: ['materials'] as const,
  feedIssues: (batchId: string) => ['feed-issues', batchId] as const,
  costEntries: (batchId?: string) => ['cost-entries', batchId ?? 'all'] as const,
  production: (batchId: string) => ['production', batchId] as const,
  sales: (batchId?: string) => ['sales', batchId ?? 'all'] as const,
  dashboard: (asOf: string) => ['reports', 'dashboard', asOf] as const,
  batchCost: (batchId: string, asOf: string) => ['reports', 'batch-cost', batchId, asOf] as const,
  /** Everything derived from the ledger. Invalidated after any write. */
  reports: ['reports'] as const,
}
